import { MutableRefObject, useEffect } from 'react'

import { useDocument } from '../hooks/useDocument.js'

export function useOnClickOutside(
  ref: MutableRefObject<Element | null>,
  handler: (event) => void | undefined,
) {
  const { document } = useDocument()
  useEffect(
    () => {
      const listener = event => {
        let inside: boolean
        if (event.composedPath) {
          inside = event.composedPath().indexOf(ref?.current) !== -1
        } else {
          inside =
            !document.documentElement.contains(event.target) ||
            ref?.current.contains(event.target)
        }

        if (!inside) {
          handler?.(event)
        }
      }

      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)

      return () => {
        document.removeEventListener('mousedown', listener)
        document.removeEventListener('touchstart', listener)
      }
    },
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler],
  )
}
